import { fetchApi } from "./fetchApi";

export default {
  list(dataType, dataTypeId, serviceAreaId) {
    const params = {
      dataType,
      dataTypeId,
      serviceAreaId,
    };

    return fetchApi({
      params,
      method: "post",
      url: "/api/auditLog",
    });
  },
  async releaseNote(releaseNoteId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/releaseNote/${releaseNoteId}`,
    });

    return response.data.result;
  },

  async serviceArea(serviceAreaId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/serviceArea/${serviceAreaId}`,
    });

    return response.data.result;
  },

  async tag(tagId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/tag/${tagId}`,
    });

    return response.data.result;
  },

  async testPlan(releaseNoteId, serviceAreaId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/testPlan/${releaseNoteId}/sa/${serviceAreaId}`,
    });

    return response.data.result;
  },

  async lastApplicationAdminUpdate(serviceAreaId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/serviceArea/${serviceAreaId}/lastApplicationAdminUpdate`,
    });

    return response.data.result;
  },

  async applicationAdminHistory(serviceAreaId) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/auditLog/serviceArea/${serviceAreaId}/applicationAdminHistory`,
    });

    return response.data.result;
  },
};
